import React, { Component } from "react";

import FSRReportRow from "./fsr-report-row";
import ExportToCSV from "./export-to-csv";

import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import WPRReportRow from "./wpr-report-row";

class Reports extends Component {
   render() {
      let reports = this.props.reports, type = this.props.type;

      return (
         <MDBContainer>
            <MDBContainer className="my-2" >
               {Object.keys(reports).length !== 0 && <ExportToCSV reports={reports} monthYear={this.props.monthYear} type={this.props.type} />}
            </MDBContainer>

            <MDBTable className="report-table" responsive bordered borderColor="primary" align="middle">
               <MDBTableHead dark>
                  {
                     type === "Free Service List" ?
                        <tr>
                           <th>Unit Serial No.</th>
                           <th>Vehicle No.</th>
                           <th>Model No.</th>
                           <th>Customer Name</th>
                           <th>Address</th>
                           <th>Date of Installation</th>
                           <th>Month Difference</th>
                        </tr> :
                        <tr>
                           <th>Job Card No.</th>
                           <th>Service Req No.</th>
                           <th>Part No.</th>
                           <th>Part Name</th>
                           <th>Quantity</th>
                        </tr>
                  }
               </MDBTableHead>

               <MDBTableBody>
                  {
                     Object.keys(reports).length !== 0 ?
                        (
                           type === "Free Service List" ?
                           reports.map((value, key) => {
                              return (
                                 <FSRReportRow key={key} value={value} keys={key} />
                              );
                           }) :
                           reports.map((value, key) => {
                              return (
                                 <WPRReportRow key={key} value={value} keys={key} />
                              )
                           })
                        ) :
                        <tr style={{ textAlign: "center" }}>
                           <td colSpan={"100%"}>No Reports found</td>
                        </tr>
                  }
               </MDBTableBody>
            </MDBTable>
         </MDBContainer>
      );
   }
}

export default Reports;